<template>
	<pre :class="[{ 'is-loading': load }, {'truncate': truncate}]" class="ui-pre  scroll-color">
		<div class="ui-pre-copied" v-if="copied">Copiado</div>

        <code v-if="!load" ref="code" class="ui-pre-code"><slot /></code>

        <div class="ui-pre-load" v-if="load">
            <ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
        </div>
    </pre>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

	export default {
		components: {
			uiLoadIndicator,
		},

		props: {
			/** Utilize para aplicar o estado de loading */
			load: {
				type: Boolean,
				required: false,
				default: false,
			},
			/** Utilize para selecionar o texto do componente */
			copy: {
				type: Boolean,
				required: false,
				default: false,
			},
			/**
			 * Utilize para definir que o componente mostrará apenas uma linha
			 * assim, com o CSS é adicionado os 3 pontos no final ...
			 */
			truncate: {
				type: Boolean,
				required: false,
				default: false,
			},
		},

		data() {
			return {
				copied: false
			}
		},

		computed: {},

		methods: {
			/**
             * Faz a seleção do texto dentro da tag <code>
             * Emite um evento @selection com o valor da seleção feita
             */
			codyCode() {
				let range = document.createRange()

				range.selectNode(this.$refs.code)
				window.getSelection().removeAllRanges()
				window.getSelection().addRange(range)
                document.execCommand('copy')

				this.copied = true

				this.$emit('selection', this.$refs.code.innerText)

				setTimeout(() => {
					this.copied = false
					document.getSelection().removeAllRanges()
				}, 2000)
			},
		},
		
		mouted() {
			this.$nextTick(() => {
				if (this.copy) this.codyCode()
			})
		},

		watch: {
			copy(value) {
				if (value) this.codyCode()
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
